(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-bar"]) return;
  try {
    
  (function () {
    const bar = document.querySelector('.benefits-bar');
    if (!bar) return;

    const track = bar.querySelector('.benefits-bar__track');
    if (!track) return;

    function isMobile() {
      return window.innerWidth <= 749;
    }

    const items = Array.from(track.querySelectorAll('.benefits-bar__item'));
    let current = 0;
    let timer = null;

    function goTo(index) {
      current = index;
      items.forEach(function (item, i) {
        item.style.opacity = i === current ? '1' : '0.4';
      });
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }

    function next() {
      goTo((current + 1) % items.length);
    }

    function startCarousel() {
      if (!isMobile()) return;
      track.style.transition = 'transform 0.5s ease';
      goTo(0);
      timer = setInterval(next, 2800);
    }

    function stopCarousel() {
      clearInterval(timer);
      timer = null;
      track.style.transform = '';
      track.style.transition = '';
      items.forEach(function (item) { item.style.opacity = ''; });
    }

    let wasCarousel = false;

    function checkMode() {
      if (isMobile() && !wasCarousel) {
        wasCarousel = true;
        startCarousel();
      } else if (!isMobile() && wasCarousel) {
        wasCarousel = false;
        stopCarousel();
      }
    }

    checkMode();
    window.addEventListener('resize', checkMode);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-avralia"]) return;
  try {
    
  class RecentlyViewedList extends HTMLElement {
    static #STORAGE_KEY = 'avralia_recently_viewed';
    static #MAX_STORED = 20;

    connectedCallback() {
      const currentHandle = this.dataset.currentHandle;
      const limit = parseInt(this.dataset.limit, 10) || 4;

      if (currentHandle) this.#saveHandle(currentHandle);

      const handles = this.#getStored()
        .filter(h => h !== currentHandle)
        .slice(0, limit);

      if (handles.length === 0) {
        this.closest('.rv-section').style.display = 'none';
        return;
      }

      const promises = handles.map(handle =>
        fetch(`/products/${handle}.js`)
          .then(r => r.ok ? r.json() : null)
          .catch(() => null)
      );

      Promise.all(promises).then(products => {
        const valid = products.filter(Boolean);
        if (valid.length === 0) {
          this.closest('.rv-section').style.display = 'none';
          return;
        }
        const listEl = this.querySelector('.rv-list');
        if (listEl) listEl.innerHTML = valid.map(p => this.#buildRow(p)).join('');
      });
    }

    #getStored() {
      try {
        return JSON.parse(localStorage.getItem(RecentlyViewedList.#STORAGE_KEY) || '[]');
      } catch {
        return [];
      }
    }

    #saveHandle(handle) {
      let items = this.#getStored().filter(h => h !== handle);
      items.unshift(handle);
      if (items.length > RecentlyViewedList.#MAX_STORED) items = items.slice(0, RecentlyViewedList.#MAX_STORED);
      try {
        localStorage.setItem(RecentlyViewedList.#STORAGE_KEY, JSON.stringify(items));
      } catch {}
    }

    #formatMoney(cents) {
      return (cents / 100).toLocaleString('ro-RO', {
        style: 'currency', currency: 'RON',
        minimumFractionDigits: 0, maximumFractionDigits: 2,
      });
    }

    #buildRow(product) {
      const image = product.images?.[0];
      const imgSrc = image ? image.src.replace(/(\.\w+)(\?.*)?$/, '_200x200$1$2') : null;
      const imgHtml = imgSrc
        ? `<img class="rv-row__img" src="${imgSrc}" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy" width="110" height="110">`
        : '';
      const compare = product.compare_at_price && product.compare_at_price > product.price
        ? `<span class="rv-row__price-compare">${this.#formatMoney(product.compare_at_price)}</span>`
        : '';
      return `<a class="rv-row" href="/products/${product.handle}">
        <div class="rv-row__img-wrap">${imgHtml}</div>
        <div class="rv-row__body">
          <span class="rv-row__title">${product.title}</span>
          <div class="rv-row__price">${compare}${this.#formatMoney(product.price)}</div>
          <span class="rv-row__btn">Vezi produs</span>
        </div>
      </a>`;
    }
  }

  if (!customElements.get('recently-viewed-list')) {
    customElements.define('recently-viewed-list', RecentlyViewedList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-avralia"]) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.rp-section-wrap[data-rp-product-id]');
    sections.forEach(function (wrap) {
      var productId = wrap.dataset.rpProductId;
      var limit = parseInt(wrap.dataset.rpLimit, 10) || 4;
      var listEl = wrap.querySelector('.rp-list');

      if (!productId || !listEl) { wrap.style.display = 'none'; return; }

      function formatMoney(price) {
        var amount = typeof price === 'string' ? parseFloat(price) : price / 100;
        if (!amount || isNaN(amount)) return '';
        return amount.toLocaleString('ro-RO', { style: 'currency', currency: 'RON', minimumFractionDigits: 0, maximumFractionDigits: 2 });
      }

      function buildRow(product, fromCollections) {
        var price = fromCollections
          ? (product.variants && product.variants[0] ? product.variants[0].price : '0')
          : product.price;
        var compareAt = fromCollections
          ? (product.variants && product.variants[0] ? product.variants[0].compare_at_price : null)
          : product.compare_at_price;
        var priceNum = typeof price === 'string' ? parseFloat(price) : price / 100;
        var compareNum = compareAt ? (typeof compareAt === 'string' ? parseFloat(compareAt) : compareAt / 100) : 0;
        var compareHtml = (compareNum > priceNum && compareNum > 0)
          ? '<span class="rp-row__price-compare">' + formatMoney(compareAt) + '</span>'
          : '';
        var image = product.images && product.images[0];
        var imgSrc = image ? image.src.replace(/(\.\w+)(\?.*)?$/, '_200x200$1$2') : '';
        var imgHtml = imgSrc
          ? '<img class="rp-row__img" src="' + imgSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="110" height="110">'
          : '';
        return '<a class="rp-row" href="/products/' + product.handle + '">'
          + '<div class="rp-row__img-wrap">' + imgHtml + '</div>'
          + '<div class="rp-row__body">'
          + '<span class="rp-row__title">' + product.title + '</span>'
          + '<div class="rp-row__price">' + compareHtml + formatMoney(price) + '</div>'
          + '<span class="rp-row__btn">Vezi produs</span>'
          + '</div></a>';
      }

      var collectionHandle = wrap.dataset.rpCollection;

      function fetchFromCollection(handle) {
        fetch('/collections/' + handle + '/products.json?limit=' + (limit + 5))
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.products || [])
              .filter(function (p) { return String(p.id) !== String(productId); })
              .slice(0, limit);
            if (items.length) {
              listEl.innerHTML = items.map(function (p) { return buildRow(p, true); }).join('');
            } else {
              wrap.style.display = 'none';
            }
          })
          .catch(function () { wrap.style.display = 'none'; });
      }

      function showFallback() {
        fetch('/collections/all/products.json?limit=' + (limit + 1))
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.products || [])
              .filter(function (p) { return String(p.id) !== String(productId); })
              .slice(0, limit);
            if (items.length) {
              listEl.innerHTML = items.map(function (p) { return buildRow(p, true); }).join('');
            } else {
              wrap.style.display = 'none';
            }
          })
          .catch(function () { wrap.style.display = 'none'; });
      }

      if (collectionHandle) {
        fetchFromCollection(collectionHandle);
      } else {
        fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data.products || []).filter(function (p) { return String(p.id) !== String(productId); });
            if (products.length) {
              listEl.innerHTML = products.map(function (p) { return buildRow(p, false); }).join('');
            } else {
              showFallback();
            }
          })
          .catch(showFallback);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-cart"]) return;
  try {
    
  class SideCartDrawer extends HTMLElement {
    #dialog = null;
    #handleCartUpdate = (event) => {
      if (event.detail?.data?.didError) return;
      if (event.detail?.data?.source !== 'product-form-component') return;

      window.location.href = '/cart';
    };

    connectedCallback() {
      this.#dialog = this.querySelector('.side-cart__dialog');

      this.querySelector('.side-cart__close')
        ?.addEventListener('click', () => this.#close());

      this.querySelector('.side-cart__continue-btn')
        ?.addEventListener('click', () => this.#close());

      this.#dialog?.addEventListener('click', (e) => {
        if (e.target === this.#dialog) this.#close();
      });

      this.#dialog?.addEventListener('cancel', (e) => {
        e.preventDefault();
        this.#close();
      });

      document.addEventListener('cart:update', this.#handleCartUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this.#handleCartUpdate);
    }

    async #fetchCartAndOpen(productId, variantId) {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        let addedItem = null;

        if (productId) {
          addedItem = cart.items.find(
            (item) => String(item.product_id) === String(productId)
          );
        }

        if (!addedItem && variantId) {
          addedItem = cart.items.find(
            (item) => String(item.variant_id) === String(variantId)
          );
        }

        if (!addedItem) {
          addedItem = cart.items[0];
        }

        if (!addedItem) return;

        this.#updateProduct(addedItem);
        this.#updateShipping(cart.total_price);

        if (productId) {
          this.#fetchRecommendations(productId);
        }

        this.#open();
      } catch (err) {
        console.error('[side-cart]', err);
      }
    }

    #updateProduct(item) {
      const productEl = this.querySelector('#side-cart-product');
      const imgEl = this.querySelector('#side-cart-img');
      const nameEl = this.querySelector('#side-cart-name');
      const priceEl = this.querySelector('#side-cart-price');

      const rawImage =
        item.featured_image?.url || item.image || '';
      const imageSrc = rawImage
        ? rawImage.replace(
            /(\.[a-z]+)(\?.*)?$/i,
            (_m, ext, qs) => `_160x160_crop_center${ext}${qs || ''}`
          )
        : '';

      if (imgEl) {
        imgEl.src = imageSrc;
        imgEl.alt = item.product_title || '';
        imgEl.hidden = !imageSrc;
      }

      if (nameEl) nameEl.textContent = item.product_title || item.title || '';
      if (priceEl) priceEl.textContent = this.#formatMoney(item.final_price);
      if (productEl) productEl.hidden = false;
    }

    #updateShipping(totalPrice) {
      const threshold =
        parseInt(this.dataset.freeShippingThreshold, 10) || 15000;
      const remaining = threshold - totalPrice;
      const progress = Math.min((totalPrice / threshold) * 100, 100);

      const shippingEl = this.querySelector('#side-cart-shipping');
      const msgEl = this.querySelector('#side-cart-shipping-msg');
      const fillEl = this.querySelector('#side-cart-progress');

      if (shippingEl) shippingEl.hidden = false;

      if (msgEl) {
        if (remaining <= 0) {
          msgEl.textContent = this.dataset.shippingAchieved || '';
          msgEl.classList.add('side-cart__shipping-msg--success');
        } else {
          const template = this.dataset.shippingMessage || '';
          msgEl.textContent = template.replace(
            '[[amount]]',
            this.#formatMoney(remaining)
          );
          msgEl.classList.remove('side-cart__shipping-msg--success');
        }
      }

      if (fillEl) {
        fillEl.style.width = `${progress}%`;
      }
    }

    async #fetchRecommendations(productId) {
      const recSection = this.querySelector('.side-cart__recommendations');
      const grid = this.querySelector('#side-cart-rec-grid');

      if (!recSection || !grid) return;

      try {
        const response = await fetch(
          `/recommendations/products.json?product_id=${productId}&limit=3&intent=related`
        );
        const data = await response.json();

        if (!data.products?.length) {
          recSection.hidden = true;
          return;
        }

        grid.innerHTML = data.products
          .map((p) => this.#renderCard(p))
          .join('');
        recSection.hidden = false;
      } catch {
        recSection.hidden = true;
      }
    }

    #renderCard(product) {
      const rawImg = product.featured_image || '';
      const imgSrc = rawImg
        ? rawImg.replace(
            /(\.[a-z]+)(\?.*)?$/i,
            (_m, ext, qs) => `_120x120_crop_center${ext}${qs || ''}`
          )
        : '';

      const img = imgSrc
        ? `<img src="${imgSrc}" alt="${this.#escape(product.title)}" loading="lazy" width="56" height="56">`
        : `<div class="side-cart__rec-img-placeholder"></div>`;

      return `<a href="${product.url}" class="side-cart__rec-card">
        <div class="side-cart__rec-img-wrap">${img}</div>
        <div class="side-cart__rec-info">
          <p class="side-cart__rec-name">${this.#escape(product.title)}</p>
          <p class="side-cart__rec-price">${this.#formatMoney(product.price)}</p>
        </div>
      </a>`;
    }

    #escape(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    #formatMoney(cents) {
      return (
        new Intl.NumberFormat('ro-RO', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(cents / 100) + ' lei'
      );
    }

    #open() {
      if (!this.#dialog || this.#dialog.open) return;
      document.body.style.overflow = 'hidden';
      this.#dialog.showModal();
      this.querySelector('.side-cart__close')?.focus();
    }

    #close() {
      if (!this.#dialog?.open) return;
      this.#dialog.classList.add('is-closing');
      setTimeout(() => {
        this.#dialog?.classList.remove('is-closing');
        this.#dialog?.close();
        document.body.style.overflow = '';
      }, 350);
    }
  }

  if (!customElements.get('side-cart-drawer')) {
    customElements.define('side-cart-drawer', SideCartDrawer);
  }

  } catch(e) { console.error(e); }
})();
})();
